"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentLocation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var CurrentLocation = function (props) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { children: (0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("circle", { opacity: "0.1", cx: "12", cy: "12", r: "12", fill: "#1990F6" }), (0, jsx_runtime_1.jsx)("circle", { opacity: "0.3", cx: "12", cy: "12", r: "9", fill: "#1990F6" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "6", fill: "#1990F6" })] }) })));
};
exports.CurrentLocation = CurrentLocation;
